import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useMediaQuery } from "@mui/material";
import "animate.css";
import { useState }  from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ReactComponent as StructureIMG } from "../../resources/images/government/circle-brands.svg";
import { ReactComponent as StructureIMG_ENG } from "../../resources/images/government/circle-brands-eng.svg";

import { ReactComponent as VipaEllipse } from "../../resources/images/government/vipa-ellipse.svg";
import { ReactComponent as BackgroundDecoration1 } from "../../resources/images/government/background-decoration.svg";
import { ReactComponent as BackgroundDecoration2 } from "../../resources/images/government/background-decoration-2.svg";
import { NavigationBar } from "../about/styles/aboutStyles";
// import { f } from "../../resources/components/navbar";
import { useLang } from "../../contexts/LangContext";

import {
  PageBackground,
  StructureHeader,
  StructureMobileWrapper,
  StructureWrapper,
  Wrapper,
} from "./styles/governmentStyles";
import styled, { keyframes } from "styled-components";
import { ReactComponent as LineBrands } from "../../resources/images/government/line-brands-pt.svg";
import { ReactComponent as LineBrandsEng } from "../../resources/images/government/line-brands-eng.svg";


const pulseAnimation = keyframes`
  0% { opacity: 30%; transform: scale(0);}
  100% { opacity: 0%;  transform: scale(1);}
`;

const RippleEffectContainer = styled.div`
  height: 340px;
  position: relative;
  width: 340px;

  position: absolute;
  z-index: 2;
  top: 49%;
  right: 49%;
  transform: translate(50%, -50%);

  & > div {
    animation: ${pulseAnimation} 3s infinite ease-out;
    background-color: white;
    border-radius: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    width: 100%;
  }
`;

// const ClickableArea = styled.div`
//   background-color: transparent;
  
//   position: absolute;
//   z-index: 1;
//   cursor: pointer;
// `;

// const CircleLinkToBrand = ({ positionTop, positionRight, link }) => {
//   const mobile = useMediaQuery("(max-width:768px)");
//   return (
//     <a href={link} target="_blank" rel="noreferrer">
//       <ClickableArea
//         target={"_blank"}
//         style={{
//           top: positionTop,
//           right: positionRight,
//           height: mobile ? "15%" : "8.5%",
//           width: mobile ? "21%" : "6.4%",
//           borderRadius: "50%",
//         }}
//       />
//     </a>
//   );
// };

function Structure() {
  const mobile = useMediaQuery("(max-width:768px)");
  const { t } = useTranslation();
  const { activeLang } = useLang();

  const SelectedImage = activeLang === "pt" ? StructureIMG : StructureIMG_ENG;
  const SelectedImageMobile = activeLang === "pt" ? LineBrands : LineBrandsEng;

  
 
  return (
    <>
      {/* navigation */}
      <NavigationBar>
        <Wrapper>
          <div className="navigationrow">
            <Link to={"/government"}>
              <ArrowBackIosIcon />
              {t("identity")}
            </Link>
            <Link to={"/government/regulations"}>
              {t("regulation")}
              <ArrowForwardIosIcon />
            </Link>
          </div>
        </Wrapper>
      </NavigationBar>

      <PageBackground style={{ backgroundColor: "#071463" }}>
        {!mobile && (
          <>
            <BackgroundDecoration1 style={{ position: "absolute", right: 0 }} />
            <BackgroundDecoration2
              style={{ position: "absolute", left: 0, bottom: "30%" }}
            />
          </>
        )}
        <Wrapper>
          <StructureHeader>{t("government_structure_title")}</StructureHeader>
          {mobile ? (
            <StructureMobileWrapper style={{ position: "relative", zIndex: 0 }}>
              {/* <LineBrands /> */}
              <SelectedImageMobile style={{ zIndex: 2, width: "400%", height: "auto" }}/>
              
              {/* <CircleLinkToBrand
                link={"https://vipa.pt"}
                positionTop={"29%"}
                positionRight={"64%"}
              />
              <CircleLinkToBrand
                link={"https://www.seehealth.pt"}
                positionTop={"29%"}
                positionRight={"-18%"}
              />
              <CircleLinkToBrand
                link={"https://www.thebiomaskcompany.pt"}
                positionTop={"40.2%"}
                positionRight={"-50.1%"}
              />
              <CircleLinkToBrand
                link={"https://www.vipaenergy.com"}
                positionTop={"29%"}
                positionRight={"-69.3%"}
              />
              <CircleLinkToBrand
                link={"https://www.vcapital.pt"}
                positionTop={"40.2%"}
                positionRight={"-103%"}
              />
              <CircleLinkToBrand
                link={"https://www.pneuzarco.pt"}
                positionTop={"29%"}
                positionRight={"-136.5%"}
              />
              <CircleLinkToBrand
                link={"https://www.ilhapneu.pt"}
                positionTop={"40.2%"}
                positionRight={"-169.2%"}
              />
              <CircleLinkToBrand
                
                link={"https://1"}
                positionTop={"28.5%"}
                positionRight={"-203%"}
              />
              <CircleLinkToBrand
                link={"https://www.nmds.pt"}
                positionTop={"40.5%"}
                positionRight={"-235.9%"}
              />
              
              <CircleLinkToBrand
                link={"https://2"}
                positionTop={"29%"}
                positionRight={"-269.5%"}
              />
              
              <CircleLinkToBrand
                link={"https://www.vipatelecom.pt"}
                positionTop={"40.5%"}
                positionRight={"-303%"}
              />
              
              <CircleLinkToBrand
                link={"https://www.vipatelecom.pt"}
                positionTop={"40.5%"}
                positionRight={"-369.5%"}
              /> */}
            </StructureMobileWrapper>
          ) : (
            <StructureWrapper style={{ position: "relative" }}>
              {/* we don't use className cause, when importing a svg as react component, the Tailwind
              styles in the className sometimes don't work  */}
              <SelectedImage style={{ zIndex: 2,width: "100%", height: "auto" }}/>;


              <RippleEffectContainer style={{ zIndex: 0,top: "45%", right: "50%",}}>
                <VipaEllipse
                  style={{
                    width: "100px",
                    position: "absolute",
                    zIndex: 1,
                    top: "50%",
                    right: "50%",
                    transform: "translate(50%, -50%)",
                  }}
                />
                <div
                  style={{
                    animationDelay: "1s",
                    animationDuration: "2s",
                    background: "white",
                  }}
                ></div>
                <div
                  style={{
                    animationDelay: "1.5s",
                    animationDuration: "2s",
                    background: "white",
                  }}
                ></div>
                <div
                  style={{
                    animationDelay: "4s",
                    animationDuration: "2s",
                    background: "white",
                  }}
                ></div>
              </RippleEffectContainer>
              
            </StructureWrapper>
          )}
        </Wrapper>
      </PageBackground>
      {/* </NavigationBar> */}
    </>
  );
}

export default Structure;
